import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function TrialDateForm({ location }) {
  console.log('TrialDateForm rendered: ', location)

  let init = {
    firstName: '',
    lastName: '',
    plaintiffStatus: [],
    currentDiagnosis: [],
    plaintiffCounsel: [],
    defenseCounsel: [],
    trialDateFrom: '',
    trialDateTo: '',
    trialDateNotSet: '',
    wasScheduledForTrial: '',
    docketNumber: '',
    dateReopenedFrom: '',
    dateReopenedTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('TrialDateForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('TrialDateForm.submitSearch', inputs)
    inputs.trialDateNotSet = (inputs.trialDateNotSet === 'on' || inputs.trialDateNotSet === 'Y') ? 'Y' : ''
    submitFormValues('TrialDateForm', navigate, inputs, 'trial.trial_date_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Trial Date Report' />
            <tbody>
              <TextInput label='First Name' name='firstName' handleInputChange={handleInputChange} defaultValue={inputs.firstName} />
              <TextInput label='Last Name' name='lastName' handleInputChange={handleInputChange} defaultValue={inputs.lastName} />
              <CustomSelectListInput label="Plaintiff Status" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} defaultValue={inputs.plaintiffStatus} />
              <CustomSelectListInput label="Current Diagnosis" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="injury" name='currentDiagnosis' multiple={true} defaultValue={inputs.currentDiagnosis} />
              <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' multiple={true} defaultValue={inputs.plaintiffCounsel} />
              <CustomSelectListInput label="Defense Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' multiple={true} defaultValue={inputs.defenseCounsel} />
              <tr>
                <td><b>Trial Date</b></td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <b>From</b><Input className="custom-input" type='date' name='trialDateFrom' onChange={handleInputChange} defaultValue={inputs.trialDateFrom} />
                  <b>To</b><Input className="custom-input" type='date' name='trialDateTo' onChange={handleInputChange} defaultValue={inputs.trialDateTo} />
                  <Input className="custom-checkbox" type="checkbox" name="trialDateNotSet" onChange={handleInputChange} defaultChecked={inputs.trialDateNotSet} /> <b> Not Set</b>
                </td>
              </tr>
              <tr>
                <td><b>Was Claim Ever Scheduled For Trial</b></td>
                <td> <Input
                  className="custom-input"
                  type="select"
                  name="wasScheduledForTrial"
                  onChange={handleInputChange}
                  style={{ width: 'auto' }}
                  defaultValue={inputs.wasScheduledForTrial}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <TextInput label='Docket Number' name='docketNumber' handleInputChange={handleInputChange} defaultValue={inputs.docketNumber} />
              <DateRangeInput label='Date Re-opened' name='dateReopened' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateReopenedFrom} defaultValueTo={inputs.dateReopenedTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

